import React, { type ReactNode } from 'react';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import ProgressBar from '@atlaskit/progress-bar';
import { InfoFlag, type FlagProps } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	id: string;
	title: string;
	description?: ReactNode;
	progress: number;
	progressAriaLabel: string;
	onDismissed: () => void;
	actions?: FlagProps['actions'];
};

export const ProgressFlag = ({
	id,
	title,
	description,
	progress,
	progressAriaLabel,
	onDismissed,
	actions,
}: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<InfoFlag
			id={id}
			title={title}
			messageId="issue-navigator-action-export-issues.common.ui.progress-flag.info-flag"
			messageType="transactional"
			description={
				<Box paddingInlineEnd="space.400">
					{description && <Box paddingBlockStart="space.100">{description}</Box>}
					<Box paddingBlockStart="space.100">
						<Stack space="space.100">
							<ProgressBar ariaLabel={progressAriaLabel} value={progress / 100} />
						</Stack>
					</Box>
					<Box paddingBlockStart="space.100">
						{formatMessage(messages.progressCompleted, {
							progress,
						})}
					</Box>
				</Box>
			}
			actions={actions}
			onDismissed={onDismissed}
		/>
	);
};
